module.exports = __webpack_public_path__ + "images/2.1782880901430.jpg";